import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/cross-black.png'


const _hoisted_1 = { class: "send-email-receipt" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Send Receipt", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_send_receipt_button = _resolveComponent("send-receipt-button")!
  const _component_powered_by_footer = _resolveComponent("powered-by-footer")!
  const _component_loading_icon = _resolveComponent("loading-icon")!
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      class: "close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }),
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
      placeholder: "Enter your email address"
    }, null, 512), [
      [_vModelText, _ctx.email]
    ]),
    _createVNode(_component_powered_by_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_send_receipt_button, {
          buttonText: 'Send',
          color: _ctx.validEmailAddress?'orange':'gray',
          onClick: _ctx.sendReceipt
        }, null, 8, ["color", "onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, { visible: _ctx.sending }, {
      default: _withCtx(() => [
        _createVNode(_component_loading_icon, {
          speed: 1000,
          mode: 'linear',
          color: '#ff5e00'
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_modal_component, { visible: _ctx.sent }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          title: _ctx.title,
          body: _ctx.body,
          buttons: 
        [{
            text:'Ok',
            handler: _ctx.hideModal
               
        }] 
        }, null, 8, ["title", "body", "buttons"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}